<div class="container-fluid banner">
  <img src="../../assets/doctor.jpg" class="img-responsive" style="width: 100%;">
  <div class="top-left ">
    <h1>Consult with Doctors <br>across specialities, <br>over video & voice calls</h1>
    <h2>Consult a Doctor from the comfort of your home</h2>
  </div>
</div>

<div class="container">
<div class="row">
    <div class="col-xs-12 col-sm-12 col-lg-12 col-md-12">
    <h1>Book Doctor Appointment</h1>
    </div>
</div>
</div>

<div class="container searchbar">
<form [formGroup]="searchForm" (ngSubmit)="getSearch()">
<div class="row">
    <div class="col-xs-12 col-sm-12 col-lg-12 col-md-12 ">
        <div class="input-group">
          <select class="btn" class="citybutton"  [(ngModel)]="countryId" [ngModelOptions]="{standalone: true}" (change)="getState(countryId)">
            <option value="">Select Country</option>
            <option *ngFor="let country of countries_list" [ngValue]="country?.countryId" class="option">{{country.countryName}}</option>
          </select>
          <select class="btn" class="citybutton" [(ngModel)]="stateId" [ngModelOptions]="{standalone: true}" (change)="getCity(stateId)">
            <option value="">Select State<span class="caret"></span></option>
            <option *ngFor="let state of states_list" [ngValue]="state.stateId">{{state.stateName}}</option>
          </select>
          <select class="btn" class="citybutton" formControlName="select_City">
            <option value="All">Select City<span class="caret"></span></option>
            <option *ngFor="let city of cities_list" value="{{city.cityName}}">{{city.cityName}}</option>
            <!-- <option *ngFor="let city of getCityNames_$" [ngValue]="city.cityName" class="option">{{city.cityName}}</option> -->
          </select>
        </div>
    </div>
</div>
<div class="row">
  <div class="col-xs-10 col-sm-10 col-lg-10 col-md-10">
      <div class="ng-autocomplete search-d">
          <ng-autocomplete [data]="data" formControlName="select_userRequired" [searchKeyword]="keyword"
          (inputChanged)='getSearchInfo($event)' (inputCleared)="searchCleared()" [itemTemplate]="itemTemplate"
            [notFoundTemplate]="notFoundTemplate" [minQueryLength]="2" [isLoading]="isLoading"
            placeholder="Search by: Doctor, specialties,symptoms,Diseases & Treatment">
          </ng-autocomplete>
          <ng-template #itemTemplate let-item>
                <small [innerHTML]='item.lable' class="forpadding"></small>
                <small [innerHTML]='item.type' class="forpadding right"></small>
          </ng-template>
          <ng-template #notFoundTemplate let-notFound>
                Not Found
          </ng-template>
      </div>
  </div>
  <div class="col-xs-2 col-sm-2 col-lg-2 col-md-2">
      <span class="input-group-btn">
        <button class="btn" class="searchbutton" type="submit">Search</button>
      </span>
  </div>
</div>
</form>
</div>

<div class="container">
  <h4 *ngIf="loader"> {{sendReq.searchKeyword !=""?sendReq.searchKeyword:'General Physician'}} in {{sendReq?.city=='All'?'All Cities':sendReq?.city}}</h4>
  
  <!-- <ng-container *ngIf="!loader">
    <img src="../../../../assets/resource/ayurls_loader.gif " alt="loader" class="img-loader">
  </ng-container> -->
  <!-- If empty to display this content -->
  <ng-container *ngIf="loader && getDoctorInfo?.content.length == 0">
    <div class="notfound">
      <p class="">No Records Found</p>
    </div>
  </ng-container>
  <!-- If not empty to display this content -->
  <ng-container *ngIf="loader && getDoctorInfo?.content?.length > 0">
    <div class="row"
      *ngFor="let doctorInfo of getDoctorInfo?.content|paginate: { itemsPerPage: 5, currentPage: p ,totalItems:getDoctorInfo?.totalElements};let i=index">
      <div class="doctorbox">
        <div class="col-lg-3 col-md-3 col-sm-12 hr1">
          <img src="assets/doctor1.jpg">
        </div>
        <div class="col-lg-5 col-md-5 col-sm-12 hr1">
          <h4>Dr {{doctorInfo?.name |titlecase}}</h4>
          <ul>
            <li><span class="glyphicon glyphicon-chevron-right"></span> Qualification: <span
                class="bold">{{doctorInfo?.qualification |titlecase}}</span>
            </li>
            <!-- <li><span class="glyphicon glyphicon-chevron-right"></span> Department: <span class="bold">{{doctorInfo?.name}}</span></li> -->
            <li><span class="glyphicon glyphicon-chevron-right"></span> Speciality: <span
                class="bold">{{doctorInfo?.speciality|titlecase}}</span></li>
            <li><span class="glyphicon glyphicon-chevron-right"></span> Locality: <span
                class="bold">{{doctorInfo?.locality|titlecase}}</span></li>
            <!-- <li><span class="glyphicon glyphicon-chevron-right"></span> Consultant: <span class="bold">Apollo
                Teleclinic,Jubile Hills</span></li> -->
            <li><span class="glyphicon glyphicon-chevron-right"></span> Language: <span
                class="bold">{{doctorInfo?.languages|titlecase}}</span></li>
            <!-- {{doctorInfo?.languages}} -->
          </ul>
        </div>
        <div class="col-lg-4 col-md-4 col-sm-12 time-location">
          <!-- <p><span class="glyphicon glyphicon-time" style="font-size: 16px;"></span> THU | FRI</p>
          <p class="time">(3:00 PM- 04:00 PM | 01:00 PM-04:00 PM)</p>
          <p><span class="glyphicon glyphicon-map-marker" style="font-size: 16px;"></span> Apollo Teleclinic</p> -->
          <button class="btn btn-primary" class="requestappoinemet" routerLink='/requestappoinment/{{doctorInfo?.doctorId}}'>request Appointment</button>
          <!-- <button class="btn btn-primary" class="requestappoinemet" data-target="#myModal" data-toggle="modal" *ngIf="getToken != null"
            (click)="getValues({doctorId:doctorInfo?.doctorId})">request Appointment</button> -->
        </div>

      </div>
    </div>
  </ng-container>
</div>
<!-- pagination -->
<div class="text-center" *ngIf="getDoctorInfo?.totalElements >5">
  <pagination-controls class="my-pagination" (pageChange)="getPagination(p=$event)"></pagination-controls>
</div>

<!-- <div class="container">
    <div class="row">
    <div class="col-lg-6 col-md-6 col-sm-12">
    <div class="row icon-left">
      
    <div class="box">
        <img src="assets/icon1.jpg">
    </div>
    <div class="box1">
      <h4 class="h">Answer about your symptoms</h4>
    </div>
  </div>
</div>
<div class="col-lg-6 col-md-6 col-sm-12">
    <div class="row icon-right">
      
    <div class="box">
        <img src="assets/icon4.jpg">
    </div>
    <div class="box1">
      <h4 class="h">Answer about your symptoms</h4>
    </div>
  </div>
</div>
</div><br>
<div class="row">
    <div class="col-lg-6 col-md-6 col-sm-12">
    <div class="row icon-left">
      
    <div class="box">
        <img src="assets/icon2.jpg">
    </div>
    <div class="box1">
      <h4 class="h">Answer about your symptoms</h4>
    </div>
  </div>
</div>
<div class="col-lg-6 col-md-6 col-sm-12">
    <div class="row icon-right">
      
    <div class="box">
        <img src="assets/icon5.jpg">
    </div>
    <div class="box1">
      <h4 class="h">Answer about your symptoms</h4>
    </div>
  </div>
</div>
</div><br>
<div class="row">
    <div class="col-lg-6 col-md-6 col-sm-12">
    <div class="row icon-left">
      
    <div class="box">
        <img src="assets/icon3.jpg">
    </div>
    <div class="box1">
      <h4 class="h">Answer about your symptoms</h4>
    </div>
  </div>
</div>
<div class="col-lg-6 col-md-6 col-sm-12">
    <div class="row icon-right">
      
    <div class="box">
        <img src="assets/icon6.jpg">
    </div>
    <div class="box1">
      <h4 class="h">Answer about your symptoms</h4>
    </div>
  </div>
</div>
</div>
</div>
<br>
<hr>
<div class="container">
  <div class="row">
  <div class="col-lg-12 col-md-12 col-sm-12">
    <h3 class="k">How it Works</h3>
  </div>
</div>
    <div class="col-lg-12 col-md-12 col-sm-12">
        <i class="arrow"></i><h5>Free,immediate health guidance</h5>
        <p>skip worrying and wondering.with just a few tabs,learn how people like you or your children(ages3+) were dianosed
            and treated by real clinicians.k health gets you fast,accurateanswers,so you start treatment sooner and feel better faster.</p>
         <a href="">Understand your symptoms</a>
    </div>
    <div class="col-lg-12 col-md-12">
      <i class="arrow"></i><h5>Chat with a clinician anytime,anywhere</h5>
        <p>convenient,text-based conversations mean you can receive reassurance,diagnosis,and treatment without office visit hassles or embarrassment.</p>
<a href="">Get started</a>
    </div>
    <div class="col-lg-12 col-md-12">
      <i class="arrow"></i><h5>Here for whatever you need</h5>
        <p>need a prescripation? we can help.lab tests? Reassurance that the bug you or your kids have isn't something serious?chick.chick.chick.And wecan do  it all remotely.no battling traffic.No crowded waiting rooms.just stress-free telemedicine</p>
<a href="">Get in touch now</a>
    </div>
    <div class="col-lg-12 col-md-12">
      <i class="arrow"></i><h5>Ongoing treatment programs</h5>
        <p>we also offer customized care programs for the active management of conditions like anxiety and depression.</p>
    <a href="">Learn more</a>
    </div>
</div>
<br> -->